// extracted by mini-css-extract-plugin
module.exports = {"form-radio-group":"_3axg_LWy","is-segmented":"_111sAWIE"};